import React from 'react'
import * as R from 'remeda'

import { type GroupAndAll } from '~/utils'

import { useTabulatedGroupsAndAll } from './useTabulatedGroupsAndAll'

export const useMapGroup = () => {
  const tabulatedGroupsAndAll = useTabulatedGroupsAndAll()

  return React.useCallback(
    <T>(
      mapFunc: (group: GroupAndAll, index: number) => T,
    ): Record<GroupAndAll, T> =>
      R.mapToObj(tabulatedGroupsAndAll, (group, index) => [
        group,
        mapFunc(group, index),
      ]),
    [tabulatedGroupsAndAll],
  )
}
